// Observability — side-effect import, must run before React renders so any
// error during initial render is captured. (OTel tracing is wired separately
// and is not present on this branch; Sentry handles errors only.)
import './observability/sentry';

import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'reactflow/dist/style.css';

import { AbilityContext, ability } from './providers';
import { store } from './store.ts';
import App from './App.tsx';
import { theme } from './theme.ts';
import './index.css';
import { Notification } from './components/Notification.tsx';

createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <AbilityContext.Provider value={ability}>
        <App />
        <Notification />
      </AbilityContext.Provider>
    </ChakraProvider>
  </Provider>
);
